<form [formGroup]="invoiceFilterForm">

    <p-toast position="top-right" key="error-invoice-filter"></p-toast>
    <!--    Start: PrimeNG Responsive Dialog For Invoice Detailed Filter-->
    <p-dialog [(visible)]="displayDetailedFilter" header="Filter Bookings" [blockScroll]="true" [modal]="true"
              [showHeader]="true"
              [breakpoints]="{'1440px': '50%' ,'1024px': '50%','960px': '50%', '640px': '90%'}"
              [style]="{width: '35%'}">

        <div class="p-d-flex p-jc-center p-ai-center">
            <div>
                <div class="p-grid">
                    <!--                    From Date-->
                    <div class="p-col-6 p-py-3">
                        <p-calendar [readonlyInput]="true" [monthNavigator]="true"
                                    appendTo="body"
                                    [yearNavigator]="true" yearRange="2000:2030" dateFormat="dd-mm-yy"
                                    showButtonBar="true" styleClass="width-100" [showIcon]="true"
                                    formControlName="fromDate"
                                    placeholder="From Date"></p-calendar>
                    </div>
                    <!--                    To Date-->
                    <div class="p-col-6 p-py-3">
                        <p-calendar [readonlyInput]="true" [monthNavigator]="true"
                                    appendTo="body"
                                    [yearNavigator]="true" yearRange="2000:2030" dateFormat="dd-mm-yy"
                                    showButtonBar="true" styleClass="width-100" [showIcon]="true"
                                    formControlName="toDate"
                                    placeholder="To Date"></p-calendar>
                    </div>

                    <div class="p-col-12 p-py-3">
                        <input type="text" (input)="onInputOfIdentifierValue('booking-id')" formControlName="bookingId"
                               pInputText class="width-100"
                               placeholder="Booking Number"/>
                    </div>

                    <div class="p-col-12 p-py-3">
                        <input type="text" (input)="onInputOfIdentifierValue('transport-document')"
                               formControlName="transportDocument" pInputText class="width-100"
                               placeholder="Transport Document"/>
                    </div>

                    <div class="p-col-12 p-py-3">
                        <input type="text" (input)="onInputOfIdentifierValue('customer-ref-number')"
                               formControlName="customerReferenceNumber" pInputText class="width-100"
                               placeholder="Customer Reference Number"/>
                    </div>


                    <div class="p-col-12 p-py-3">
                        <p-multiSelect
                                appendTo="body"
                                #orderTypeSelection
                                optionValue="orderType"
                                styleClass="width-100"
                                optionLabel="orderType"
                                [options]="shipmentTypes"
                                [placeholder]="'Select Job Types'"
                                formControlName="orderTypes">
                            <ng-template pTemplate="header">

                                <div class="apply-button p-ai-center">
                                    <button class="p-button-icon"
                                            (click)="onSubmitInvoiceFilterForm($event,'job-types'); orderTypeSelection.close($event)"
                                            pButton pRipple type="button" icon="pi pi-check"></button>
                                </div>

                            </ng-template>
                        </p-multiSelect>
                    </div>

                    <div class="p-col-6 p-py-3 p-text-right">
                        <button pButton class="button-height p-px-5 p-button-info"
                                (click)="onSubmitInvoiceFilterForm($event)"
                                label="Apply"
                        ></button>
                    </div>
                    <div class="p-col-6 p-py-3 p-text-left">
                        <button pButton class="button-height p-px-5 p-button-info p-button-outlined"
                                (click)="resetBookingFilterForm()" label="Clear"
                        ></button>
                    </div>
                </div>
            </div>
        </div>

    </p-dialog>
    <!--    End: PrimeNG Responsive Dialog For Invoice Detailed Filter-->


    <div class="p-text-center" *ngIf="isLoading">
        <div class="p-text-center">
            <div>
                <i class="p-text-secondary pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
            </div>
            <div class="p-mt-3">
                <h5 class="p-text-secondary">Loading !</h5>
            </div>
        </div>
    </div>

    <div class="p-grid p-ai-start p-jc-between p-pt-3" *ngIf="!isLoading">
        <!--        Start : Invoice Number Search-->
        <div class="p-col-10 p-lg-7 p-xl-4">
            <div>
                    <span class="p-input-icon-right p-float-label width-100">
                        <input (change)="onSearchOfInvoiceNumber()" formControlName="filterByIdentifier" type="text"
                               pInputText class="width-100"/>
                        <label>Invoice Number</label>
						<i class="pi pi-search"></i>
					</span>
            </div>
            <div class="p-mt-2" *ngIf="isAdmin">
                <p-dropdown (onChange)="applyCustomerFilter()" [filter]="true"
                            [options]="customers"
                            [showClear]="invoiceFilterForm?.value?.businessEntityId?.length > 0"
                            appendTo="body"
                            emptyFilterMessage="Filtered Value not found"
                            emptyMessage="No Customers Found"
                            filterBy="name"
                            formControlName="businessEntityId"
                            optionValue="businessEntityId"
                            optionLabel="name"
                            placeholder="Select Customer..">
                    <ng-template let-customer pTemplate="items">
                        {{customer?.name}}
                    </ng-template>
                </p-dropdown>
            </div>
        </div>
        <!--        End : Invoice Number Search-->
        <!--        FilterOption Button for Detailed Invoice Filter-->
        <div class="p-col-2 p-lg-3 p-xl-2 p-text-right">
            <img class="p-cursor" (click)="displayDetailedFilter = true"
                 src="assets/branding/shared-icons/filter-secondary.svg" style="height: calc(2rem + 1vmin);" alt=""
                 pRipple>
        </div>
    </div>
</form>

